module.exports = "pegasus/assets/blocks/capture-2-basic.png";